import React from "react";
import Images from "../../../assets/images/index";
import { Navigate, useNavigate } from "react-router-dom";

export default function Success(){
    let navigate = useNavigate();
    const goBackSubscription = () =>{
        navigate('/package/Basic');
    }
    return(
        <div className="success_wrapper text-center">
            <figure>
                <img src={Images.Error} alt="" className="img-fluid"/>
            </figure>
            <div className="success_content">
                <h6>Transaction Error</h6>
                <p>Your Transaction wasn’t successful , Try again</p>
                <div className="sucess_btn">
                    <button type="button" className="btn btn_success" onClick={()=>goBackSubscription()}>Go Back</button>
                </div>
            </div>
        </div>
    )
}